import { apiGet, apiPost, apiPut } from './api';

export function getQueueOverview() {
  return apiGet('/api/queue');
}

export function listQueueBatches() {
  return apiGet('/api/queue/batches');
}

export function getQueueBatch(batchId) {
  return apiGet(`/api/queue/batches/${batchId}`);
}

export async function cancelQueueBatch(batchId) {
  const { data } = await apiPost(`/api/queue/batches/${batchId}/cancel`, {});
  return data;
}

export function rescheduleQueueBatch(batchId, sendAt) {
  return apiPut(`/api/queue/batches/${batchId}/reschedule`, { sendAt });
}
